import { Pipe, PipeTransform } from '@angular/core';
import { OrganizationProfile } from '../../models/entities/organization-profile';
import { ConfigGeoRegions } from '../../config/geo-regions';

@Pipe({
    standalone: true,
    name: 'profileAddress',
})
export class ProfileAddressPipe implements PipeTransform {
    // TODO: support units and other addresses as needed
    transform(profile: OrganizationProfile, innerHtml = false, spanClass = '', abbreviatedState = true): string {
        if (!profile) {
            return 'Missing profile';
        }

        let address = '';
        if (profile.address1) {
            address += profile.address1 + ' ';
        }
        if (profile.address2) {
            address += profile.address2 + ' ';
        }

        let geographicLocation = '';
        if (profile.city) {
            geographicLocation += profile.city;
        }
        if (profile.state) {
            let state = profile.state;
            if (abbreviatedState) {
                const region = ConfigGeoRegions.RegionsByCountry[0].regions.find(
                        (s) => s.region === state
                );
                state = region.abbreviation;
            }

            geographicLocation += (profile.city ? ', ' : '') + state;
        }
        if (profile.zip) {
            geographicLocation += ' ' + profile.zip;
        }

        if (!innerHtml) {
            return address + geographicLocation;
        }

        if (address !== '') {
            address = spanClass ? `<span class="${spanClass}">${address}</span>` : `<span>${address}</span>`;
        }

        if (geographicLocation !== '') {
            geographicLocation = spanClass ? `<span class="${spanClass}">${geographicLocation}</span>` : `<span>${geographicLocation}</span>`;
        }

        return `<address>${address}${geographicLocation}</address>`;
    }
}
